module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_20_4.e260c655.jpeg";